export default __webpack_public_path__ + "static/banner-wealth-7e37428d3e76c2168b24ab4309666da4.svg";